/**
 * Collection Slider JavaScript
 * Handles dynamic height calculation and responsive slide width adjustments
 */

function changeCollectionSliderHeight() {
	let maxHeight = 0;
	// Target the actual product grid items inside the slides
	document.querySelectorAll('.collection-slider-section .collection-products-slideshow .grid-product, .collection-slider-section .collection-products-slideshow .collection-product-item').forEach((el) => {
		// Reset height first
		el.style.height = 'auto';
		if (el.offsetHeight > maxHeight) {
			maxHeight = el.offsetHeight;
		}
	});
	
	// Ensure we have a minimum height
	if (maxHeight < 300) {
		maxHeight = 400;
	}
	
	maxHeight += 30;

	// Apply to slideshow elements specifically
	document.querySelectorAll('.collection-slider-section .collection-products-slideshow .slideshow__slide, .collection-slider-section .collection-products-slideshow .flickity-viewport, .collection-slider-section .collection-products-slideshow').forEach((el) => {
		el.style.height = maxHeight + 'px';
	});
}

function changeCollectionTabsSliderHeight() {
	// For tab replacement collections, we want square images that fill the slide width
	const tabSliders = document.querySelectorAll('.collection-tabs-slider-section .collection-tabs-slideshow');
	
	tabSliders.forEach(slider => {
		// First, make images square (100% width of slide, let aspect-ratio handle height)
		slider.querySelectorAll('.tab-replacement__item img').forEach((img) => {
			img.style.width = '100%';
			img.style.height = 'auto'; // Let aspect-ratio handle the height
			img.style.objectFit = 'cover';
			img.style.aspectRatio = '1 / 1';
		});
		
		// Wait for Flickity to initialize and render, then calculate height
		setTimeout(() => {
			const flickitySlider = slider.querySelector('.flickity-slider');
			let calculatedHeight = 0;
			
			if (flickitySlider) {
				const sliderWidth = flickitySlider.offsetWidth;
				const windowWidth = window.innerWidth;
				
				// Determine slides per view based on screen size
				let slidesPerView;
				if (windowWidth >= 1025) {
					// Desktop - 4 slides
					slidesPerView = 4;
				} else if (windowWidth >= 768) {
					// Tablet - 3 slides
					slidesPerView = 3;
				} else {
					// Mobile - 2 slides
					slidesPerView = 2;
				}
				
				// Calculate height: slider width divided by slides per view + 50px
				const slideWidth = sliderWidth / slidesPerView;
				calculatedHeight = slideWidth + 50;
			} else {
				// Fallback if flickity-slider not found
				calculatedHeight = 200;
			}
			
			// Apply the calculated height to all slides and slider elements
			slider.querySelectorAll('.slideshow__slide, .flickity-viewport').forEach((el) => {
				el.style.height = calculatedHeight + 'px';
			});
			
			// Set the main slider container height
			slider.style.height = calculatedHeight + 'px';
		}, 100); // Slightly longer delay to ensure Flickity has initialized
	});
}

function recalculateCollectionSlideWidths() {
	const sliders = document.querySelectorAll('.collection-slider-section .collection-products-slideshow');
	
	sliders.forEach(slider => {
		const slides = slider.querySelectorAll('.slideshow__slide');
		const windowWidth = window.innerWidth;
		
		// Get the responsive values from data attributes
		let slidesPerView;
		
		if (windowWidth >= 1025) {
			// Desktop
			slidesPerView = parseInt(slider.dataset.desktopSlides) || 4;
		} else if (windowWidth >= 768) {
			// Tablet  
			slidesPerView = parseInt(slider.dataset.tabletSlides) || 3;
		} else {
			// Mobile
			slidesPerView = parseInt(slider.dataset.mobileSlides) || 2;
		}
		
		// Calculate width for each slide
		const slideWidth = `calc(100% / ${slidesPerView} - 15px)`;
		
		slides.forEach((slide, index) => {
			slide.style.width = slideWidth;
			slide.style.setProperty('width', slideWidth, 'important');
		});
		
		// Trigger Flickity resize if available - try multiple methods
		let flickityInstance = null;
		
		// Method 1: Check slider.flickity
		if (slider.flickity) {
			flickityInstance = slider.flickity;
		}
		// Method 2: Check if Flickity is available globally and get instance
		else if (window.Flickity) {
			flickityInstance = window.Flickity.data(slider);
		}
		// Method 3: Check jQuery Flickity (if using jQuery)
		else if (window.$ && window.$.fn.flickity) {
			try {
				flickityInstance = window.$(slider).data('flickity');
			} catch(e) {
				// Silently handle jQuery Flickity errors
			}
		}
		
		if (flickityInstance) {
			flickityInstance.resize();
			// Force a reposition to ensure slides are properly arranged
			setTimeout(() => {
				flickityInstance.reposition();
				flickityInstance.settle();
			}, 50);
		} else {
			// Force a reflow by temporarily hiding and showing
			slider.style.display = 'none';
			slider.offsetHeight; // Trigger reflow
			slider.style.display = '';
		}
	});
}

function recalculateCollectionTabsSlideWidths() {
	const tabSliders = document.querySelectorAll('.collection-tabs-slider-section .collection-tabs-slideshow');
	
	tabSliders.forEach(slider => {
		const slides = slider.querySelectorAll('.slideshow__slide');
		const windowWidth = window.innerWidth;
		
		// Get the responsive values from data attributes
		let slidesPerView;
		
		if (windowWidth >= 1025) {
			// Desktop
			slidesPerView = parseInt(slider.dataset.desktopSlides) || 5;
		} else if (windowWidth >= 768) {
			// Tablet  
			slidesPerView = parseInt(slider.dataset.tabletSlides) || 3;
		} else {
			// Mobile
			slidesPerView = parseInt(slider.dataset.mobileSlides) || 2;
		}
		
		// Calculate width for each slide
		const slideWidth = `calc(100% / ${slidesPerView} - 15px)`;
		
		slides.forEach((slide, index) => {
			slide.style.width = slideWidth;
			slide.style.setProperty('width', slideWidth, 'important');
		});
		
		// Trigger Flickity resize if available - try multiple methods
		let flickityInstance = null;
		
		// Method 1: Check slider.flickity
		if (slider.flickity) {
			flickityInstance = slider.flickity;
		}
		// Method 2: Check if Flickity is available globally and get instance
		else if (window.Flickity) {
			flickityInstance = window.Flickity.data(slider);
		}
		// Method 3: Check jQuery Flickity (if using jQuery)
		else if (window.$ && window.$.fn.flickity) {
			try {
				flickityInstance = window.$(slider).data('flickity');
			} catch(e) {
				// Silently handle jQuery Flickity errors
			}
		}
		
		if (flickityInstance) {
			flickityInstance.resize();
			// Force a reposition to ensure slides are properly arranged
			setTimeout(() => {
				flickityInstance.reposition();
				flickityInstance.settle();
			}, 50);
		} else {
			// Force a reflow by temporarily hiding and showing
			slider.style.display = 'none';
			slider.offsetHeight; // Trigger reflow
			slider.style.display = '';
		}
	});
}

// Initialize collection slider functionality
function initializeCollectionSlider() {
	// Multiple triggers to ensure height gets calculated
	window.addEventListener('load', () => {
		setTimeout(() => {
			changeCollectionSliderHeight();
			changeCollectionTabsSliderHeight();
		}, 100);
	});

	// Throttled resize function to prevent too many calls
	let resizeTimeout;
	window.addEventListener('resize', () => {
		clearTimeout(resizeTimeout);
		resizeTimeout = setTimeout(() => {
			changeCollectionSliderHeight();
			changeCollectionTabsSliderHeight();
			recalculateCollectionSlideWidths();
			recalculateCollectionTabsSlideWidths();
		}, 100);
	});

	// Also trigger after images load
	document.addEventListener('DOMContentLoaded', () => {
		setTimeout(() => {
			changeCollectionSliderHeight();
			changeCollectionTabsSliderHeight();
			// Wait a bit longer for Flickity to fully initialize before setting widths
			setTimeout(() => {
				recalculateCollectionSlideWidths();
				recalculateCollectionTabsSlideWidths();
			}, 200);
			
			// Fix slider boundaries for product sliders
			const sliders = document.querySelectorAll('.collection-slider-section .collection-products-slideshow');
			sliders.forEach(slider => {
				if (slider.flickity) {
					const totalProducts = parseInt(slider.dataset.totalProducts) || 0;
					const originalNext = slider.flickity.next;
					const originalPrevious = slider.flickity.previous;
					
					// Override next method
					slider.flickity.next = function() {
						if (this.selectedIndex < totalProducts - 1) {
							originalNext.call(this);
						}
					};
					
					// Override previous method  
					slider.flickity.previous = function() {
						if (this.selectedIndex > 0) {
							originalPrevious.call(this);
						}
					};
				}
			});
			
			// Fix slider boundaries for tab sliders
			const tabSliders = document.querySelectorAll('.collection-tabs-slider-section .collection-tabs-slideshow');
			tabSliders.forEach(slider => {
				if (slider.flickity) {
					const totalItems = parseInt(slider.dataset.totalItems) || 0;
					const originalNext = slider.flickity.next;
					const originalPrevious = slider.flickity.previous;
					
					// Override next method
					slider.flickity.next = function() {
						if (this.selectedIndex < totalItems - 1) {
							originalNext.call(this);
						}
					};
					
					// Override previous method  
					slider.flickity.previous = function() {
						if (this.selectedIndex > 0) {
							originalPrevious.call(this);
						}
					};
				}
			});
		}, 500);
	});
}

// Auto-initialize when script loads
if (document.readyState === 'loading') {
	document.addEventListener('DOMContentLoaded', initializeCollectionSlider);
} else {
	initializeCollectionSlider();
}
